import React, { useState } from 'react'
import { HeaderMenu } from '../../component/HeaderMenu'
import { GetTasks } from '../../api/GetTasks.api';
import { TextField } from '@mui/material';

import { useNavigate } from 'react-router-dom';
import { OtPdf } from './OtPdf.page';
import { OtPdf_big } from './OtPdf_big.page';
import { ModalLoaded } from '../../component/ModalLoaded.component';

import PrintIcon from '@mui/icons-material/Print';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

export const PDFforImpreso = () => {

    const navigate = useNavigate();

    const [ModalLoadded, setModalLoadded] = useState(false);
    const [ModalLoadded_, setModalLoadded_] = useState(false);
    const [Texto, setTexto] = useState('');
    
    const [TaskBulk, setTaskBulk] = useState();
    const [OtBulk, setOtBulk] = useState();

    const [btnBulk, setBtnBulk] = useState([]);

    // genera el PDF de la OT seleccionada
    const GenerarPDF_NOW = async (otData) => {
        setTexto('Validando el Folio de la OT, por favor espere...')
        setModalLoadded_(true);
        let otData_ = otData;
        if (!otData_ || otData_.length <= 5) {
            alert('No se ha proporcionado un folio de OT válido.');
            await setModalLoadded_(false);
            return;
        }else{
            if(String(otData_).startsWith('OT') || String(otData_).startsWith('ot')){
                otData_ = String(otData_).toUpperCase();
            }else{
                otData_ = 'OT' + String(otData_).toUpperCase();
            }
        }
        // console.log(otData_)
        setTexto('Estamos Generando el PDF para usted.')
        const tasks = await GetTasks({wofolio:otData_})
        // console.log(tasks.length)
        if(tasks.length===0){
            alert('No se encontraron tareas para la OT: ' + otData_);
            await setModalLoadded_(false);
        }else{
            await setTaskBulk(tasks)
            await setModalLoadded_(false);
            await setOtBulk(otData_)
            await setModalLoadded(true)
        }

    }

    const GenerarPDF_BULK = async (valor) => {
        // console.log(valor)
        if(valor > 100){
            alert('El número máximo de OTs a generar es 100');
            return;
        }else if(valor < 1){
            alert('Debe ingresar al menos 1 OT a generar');
            return;
        }else{

            let blk = []
            for (let arr = 1; arr <= valor; arr++) {
                blk.push(arr)
            }
            setBtnBulk(blk);
        }
    }

    return (<>
        <HeaderMenu Pag_Sel={'entrega_turno'} />
        <div className='container'>

            <div className='row'>
                <div className='col-3 mt-3'></div>
                <div className='col-6 mt-3'>
                    <TextField
                        id='ndatas'
                        type='number'
                        label="Ingrese cantidad de OT a generar"
                        variant="outlined"
                        fullWidth
                        size='small'
                    />
                </div>
                <div className='col-1 mt-3'>
                    <button className='btn btn-primary' onClick={() => GenerarPDF_BULK(document.getElementById('ndatas').value)}><AddCircleOutlineIcon/></button>
                </div>
                <div className='col-3 mt-3'></div>
            </div>

            <div className='row mb-5 mt-4'>
            {
                btnBulk.length > 0 &&
                btnBulk.map((item, index) => (
                    <div className='col-6 '  key={index}>
                    <div className='row m-1' style={{border:"1px solid rgb(232, 232, 232)", padding:"20px 5px", borderRadius:"5px", boxShadow:"3px 3px 5px #cacaca"}}>
                        <div className='col-8'>
                            <TextField
                                id={`WOFOLIO_${index}`}
                                label={`Ingrese el Numero de la OT ${index + 1}`}
                                variant="outlined"
                                fullWidth
                                size='small'
                            />
                        </div>
                        <div className='col-4'>
                            <button
                                className='btn btn-success'
                                onClick={() => GenerarPDF_NOW(document.getElementById(`WOFOLIO_${index}`).value)}
                            >
                                <PrintIcon />
                            </button>
                        </div>
                    </div>
                    </div>
                ))
            }
            </div>
        </div>
        {
            ModalLoadded && 
            <div className='modal-ot-pfd'>
                <OtPdf_big TASK={TaskBulk} OT={OtBulk} ModalLoadded={ModalLoadded} setModalLoadded={setModalLoadded}/>
            </div>
        }

        {
            ModalLoadded_?<ModalLoaded texto={Texto} />:null
        }
    </>
    )
}
